import { PhoneValidationStore } from '@stores/PhoneValidationStore';
import { apiResponse } from '@stores';
import { useMutation } from '@tanstack/react-query';

export class ValidatePhoneValidationCodeAction {
  constructor(private readonly phoneValidationStore: PhoneValidationStore = new PhoneValidationStore()) {}

  public Execute = async (phoneNumber: string, code: string) => {
    try {
      const result = await apiResponse.handleApiResponse(async () =>
        this.phoneValidationStore.validateCode(phoneNumber, code)
      );
      return result;
    } catch (e: any) {
      return {
        statusCode: e.cause?.statusCode ?? 0,
        message: e.cause.message ?? '',
      };
    }
  };
}

export const useValidatePhoneValidationCodeAction = () =>
  useMutation({
    mutationFn: async (param: { phoneNumber: string; code: string }) => {
      const action = new ValidatePhoneValidationCodeAction();
      return action.Execute(param.phoneNumber, param.code);
    },
  });
